import hash from 'object-hash'

const stateObj = {
  responses: {},
}

const getters = {
  getResponseByUrl: (state) => (url) => {
    if (!USE_CACHE) return null
    const key = hash(url)
    return !(key in state.responses) ? null : state.responses[key]
  },
}

const mutations = {
  addResponse (state, payload) {
    const key = hash(payload.url)
    state.responses[key] = payload.response
  },
  updateResponse (state, payload) {
    const key = hash(payload.url)
    if (key in state.responses) {
      for (const responseKey in state.responses[key]) {
        if (responseKey in payload.response) {
          state.responses[key][responseKey] = payload.response[responseKey]
        }
      }
    }
  },
  resetResponse (state, url) {
    const key = hash(url)
    delete state.responses[key]
  },
  resetAllResponses (state) {
    state.responses = {}
  },
}

export default {
  state: stateObj,
  getters,
  mutations,
}
